import {getPolishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Oceń artykuł',
    message: 'Głos oddany',
    votes: votes => `${getPolishPlurals(["opinia", "opinie", "opinii"], +votes)},`,
    score: 'ocena',
  },
  feedback: {
    label: 'Czy ten artykuł jest pomocny?'
  }
};
